export var getInitials = function (account) {
    if (!(account === null || account === void 0 ? void 0 : account.friendlyName)) {
        return "ME";
    }
    var _a = account.friendlyName.split(" ", 2), firstName = _a[0], lastName = _a[1];
    return "".concat(firstName[0]).concat(lastName ? lastName[0] : "");
};
